import React, { useEffect } from 'react';

import { loadConfiguration, reloadConfiguration } from 'common/actions/ideasConfiguration';
import connect from 'common/core/connect';
import { type IdeasConfigurationState, defaultState } from 'common/reducers/ideasConfiguration';

import type { State } from 'redux-connect';

type IdeaConfiguration = NonNullable<IdeasConfigurationState['data']>;
type IdeaFields = IdeaConfiguration['fields'];
type IdeaStatuses = IdeaConfiguration['statuses'];

type IdeasConfigurationContextValue = {
  ideasConfiguration: Omit<IdeasConfigurationState, 'data'>;
  ideaFields: IdeaFields | null;
  ideaStatuses: IdeaStatuses | null;
  loadConfiguration: () => Promise<void>;
  reloadConfiguration: () => Promise<void>;
};

const { data: _, ...defaultIdeasConfiguration } = defaultState;
const notReady = () => Promise.reject(new Error('Ideas configuration context is not ready'));
export const IdeasConfigurationContext = React.createContext<IdeasConfigurationContextValue>({
  ideasConfiguration: defaultIdeasConfiguration,
  ideaFields: null,
  ideaStatuses: null,
  loadConfiguration: notReady,
  reloadConfiguration: notReady,
});

type OwnProps = {
  children: React.ReactNode;
};

function IdeasConfigurationContainer({
  children,
  ideasConfiguration,
  ideaFields,
  ideaStatuses,
  loadConfiguration,
  reloadConfiguration,
}: IdeasConfigurationContextValue & OwnProps) {
  useEffect(() => {
    loadConfiguration();
  }, [loadConfiguration]);

  const contextValue = {
    ideasConfiguration,
    ideaFields,
    ideaStatuses,
    loadConfiguration,
    reloadConfiguration,
  };
  return (
    <IdeasConfigurationContext.Provider value={contextValue}>
      {children}
    </IdeasConfigurationContext.Provider>
  );
}

const mapDispatchToProps = { loadConfiguration, reloadConfiguration };
export default connect(({ ideasConfiguration }: State) => {
  const { data, ...rest } = ideasConfiguration;
  return {
    ideasConfiguration: rest,
    ideaFields: data?.fields ?? null,
    ideaStatuses: data?.statuses ?? null,
  };
}, mapDispatchToProps)(IdeasConfigurationContainer) as unknown as React.FC<OwnProps>;
